module.exports = __webpack_public_path__ + "media/frog.7c765ed9.mp3";